import { PDFDocument } from "pdf-lib";
import fontkit from "@pdf-lib/fontkit";

// Serializers
import TriageSerializerForUpdate from 'issara-sdk/types/TriageSerializerForUpdate_core'
import PatientSerializer from 'issara-sdk/types/PatientSerializer_apps_REG'
import EncounterSerializer from 'issara-sdk/types/EncounterSerializer_core'
import AdverseReactionSerializerForCreate from 'issara-sdk/types/AdverseReactionSerializerForCreate_apps_ADR'

// Utils
import { adToBe, dateToStringWithoutTimeBE } from "react-lib/utils/dateUtils";
import { drawTextOnPage, truncateText, calculateCenterX } from "react-lib/apps/common/pdfPrintList/StaticPdfUtils";
import moment from "moment";

const PDF = "static/pdf/printList/form_lmr.pdf";
const FONTS = "/static/fonts/THSarabunNew-Bold.ttf";

type FormLMRProps = {
  triage: TriageSerializerForUpdate | null;
  patient: PatientSerializer;
  encounter: EncounterSerializer;
  allergy: AdverseReactionSerializerForCreate;
  currentMeds: string | null;
};

const FormLMR = async (props: FormLMRProps) => {
  try {
    console.log("Yeti [FormLMR]: ", props);

    const existingPdfBytes = await fetch(PDF).then((res) => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    // Loading Custom Font
    const fontBytes = await fetch(FONTS).then((res) => res.arrayBuffer());
    pdfDoc.registerFontkit(fontkit);
    const customFonts = await pdfDoc.embedFont(fontBytes);
  
    const pages = pdfDoc.getPages();
    const fontsSizes = 14;

    const patientAddress = [
      props.patient?.present_address?.no || "",
      props.patient?.present_address?.name || "",
      props.patient?.present_address?.town || "",
      props.patient?.present_address?.road || "",
      props.patient?.present_address?.street || "",
      props.patient?.present_address?.city_label || "",
      props.patient?.present_address?.district_label || "",
      props.patient?.present_address?.province_label || "",
      props.patient?.present_address?.zipcode || "",
    ];

    const formatPatientAddress = patientAddress.filter(item => item).join(" ");

    const currentDate = moment();

    // Page 1
    const pageOneCoordinates = [
      { text: props.encounter?.hn || "", x: 132, y: 660 },
      { text: adToBe(props.encounter?.queue_date || "", "YYYY-MM-DD"), x: 371, y: 660 },

      { text: props.patient?.full_name || "", x: 135, y: 639 },
      { text: props.patient?.citizen_no || "", x: 431, y: 639 },

      { text: props.patient?.gender === "F" ? "X" : "", x: 109, y: 618 },
      { text: props.patient?.gender === "M" ? "X" : "", x: 150, y: 618 },
      { text: props.patient?.birthdate || "", x: 287, y: 619 },
      { text: props.patient?.age ? `${props.patient.age} ปี` : "", x: 423, y: 619 },

      { text: props.patient?.main_contact_phone_no || "", x: 120, y: 597 },
      { text: props.patient?.email || "", x: 257, y: 597 },
      { text: props.patient?.line_id || "", x: 438, y: 597 },

      { text: truncateText(formatPatientAddress, customFonts, fontsSizes, 97, 503), x: 97, y: 577 },

      // TODO: Triage Section
      { text: props.encounter?.chief_complaints || props.triage?.chief_complaint || "", x: 234, y: 501 },
      { text: props.encounter?.underlying_disease || "", x: 142, y: 480 },
      { text: props.allergy?.name || "", x: 142, y: 459 },
      { text: props.currentMeds || "", x: 233, y: 438 }, // TODO: ยาประจำ
      { text: props.encounter?.preparation_before_exam === "FASTING" ? "X" : "", x: 185, y: 416 }, // TODO: checkbox งดอาหาร
      { text: props.encounter?.preparation_before_exam === "FASTING" && props.encounter?.preparation_remark, x: 255, y: 417 }, // TODO: ชั่วโมงงดอาหาร
      { text: props.encounter?.preparation_before_exam === "NO_FASTING" ? "X" : "", x: 326, y: 416 }, // TODO: checkbox ไม่งดอาหาร
      { text: props.encounter?.preparation_before_exam === "OTHER" ? "X" : "", x: 398, y: 416 }, // TODO: checkbox อื่น ๆ
    
      // TODO: Order & Collection
      { text: "", x: 157, y: 362 }, // TODO: รายการที่สั่ง
      { text: "", x: 165, y: 340 }, // TODO: checkbox ปัสสาวะ
      { text: "", x: 256, y: 340 }, // TODO: checkbox อุจจาระ
      { text: "", x: 306, y: 340 }, // TODO: checkbox อื่น ๆ
      { text: "", x: 342, y: 340 }, // TODO: อื่น ๆ
      { text: "", x: 176, y: 320 }, // TODO: วันเวลาเก็บตัวอย่าง
      { text: "", x: 423, y: 320 }, // TODO: ผู้เก็บตัวอย่าง
      { text: "", x: 156, y: 299 }, // TODO: checkbox ปกติ
      { text: "", x: 195, y: 299 }, // TODO: checkbox Hemolysis
      { text: "", x: 271, y: 299 }, // TODO: checkbox Lipemia
      { text: "", x: 335, y: 299 }, // TODO: checkbox อื่น ๆ
      { text: "", x: 370, y: 299 }, // TODO: อื่น ๆ
    
      // TODO: Lab Summary
      { text: "", x: 79, y: 222 }, // TODO: checkbox ไม่มี
      { text: "", x: 122, y: 222 }, // TODO: checkbox มี
      { text: "", x: 188, y: 223 }, // TODO: ผู้แจ้งผล
      { text: "", x: 411, y: 223 }, // TODO: วันที่เวลาแจ้งผล
      { text: "", x: 190, y: 202 }, // TODO: ผู้รายงาน
      { text: "", x: 409, y: 202 }, // TODO: วันที่เวลารายงาน
      { text: "แอปพลิเคชัน MeHealth / LINE Official", x: 165, y: 181 }, // TODO: ช่องทางรายงาน
      
      { text: dateToStringWithoutTimeBE(currentDate), x: calculateCenterX(dateToStringWithoutTimeBE(currentDate), customFonts, fontsSizes, 119, 287), y: 97 },
      { text: dateToStringWithoutTimeBE(currentDate), x: calculateCenterX(dateToStringWithoutTimeBE(currentDate), customFonts, fontsSizes, 361, 504), y: 97 },
    ];

    drawTextOnPage(pages[0], pageOneCoordinates, customFonts, fontsSizes);

    const pdfBytes = await pdfDoc.save();
    return pdfBytes;
  } catch (err) {
    console.error("Error modifying PDF: ", err);
    return;
  }
};

export default FormLMR;